// Sidebar container
export const sidebarContainerSx = {
  position: 'fixed',
  top: 0,
  left: 0,
  height: '100vh',
  backgroundColor: '#FFFFFF',
  borderRight: '1px solid #E3E3E3',
  display: 'flex',
  flexDirection: 'column',
  boxShadow: '2px 0 4px rgba(0, 0, 0, 0.1)',
  transition: 'width 0.3s ease',
  zIndex: 10,
};

// Icon list container (scrollable)
export const sidebarIconsContainerSx = (isExpanded) => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: isExpanded ? 'flex-start' : 'center',
  paddingTop: '6rem',
  gap: '1rem',
  paddingLeft: isExpanded ? '0.5rem' : 0,
  paddingRight: isExpanded ? '0.5rem' : 0,
  overflowY: 'auto',
  overflowX: 'hidden',
  maxHeight: '100vh',
  transition: 'all 0.3s ease',
});

// Highlight active icon
export const activeIconSx = {
  color: '#5236AB',
};

// Icon button style
export const sidebarIconButtonSx = {
  width: '3rem',
  height: '2.25rem',
  px: '0.75rem',
  borderRadius: '0.5rem',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  transition: 'all 0.2s ease',
};

// Text beside icons
export const expandedTextSx = {
  fontSize: '0.875rem',
  color: '#333',
  whiteSpace: 'nowrap',
  opacity: 0,
  transform: 'translateX(-10px)',
  transition: 'opacity 0.3s ease, transform 0.3s ease',
};

// Expand/collapse toggle icon color
export const toggleIconColor = (isExpanded) => ({
  color: isExpanded ? '#5236AB' : '#666',
});

// Default icon color when inactive
export const defaultIconColor = {
  color: '#666',
};

// Submenu arrow icon
export const submenuArrowSx = {
  color: '#999',
};
